
import axios            from "@/axios/axios";
import createDictionary from "@/helpers/createDictionary";

export default createDictionary({
  loadData: () => axios.get('privilege_ownership_limits'),
});
